import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import { g as getIconCompoment } from './common-dbaafe9f.js';
import '@teko-builder/types/pb';
import { getStyle } from './utils.es.js';

const PbIcon = (props) => {
    const { commonStyle } = props, rest = __rest(props, ["commonStyle"]);
    const IconComponent = getIconCompoment(rest);
    return (jsx(IconWrapper, Object.assign({ commonStyle: commonStyle }, rest, { children: IconComponent })));
};
const IconWrapper = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)};
  > svg {
    display: inline-block;
  }
`);
PbIcon.displayName = 'Icon';

export { PbIcon as P };
